import { render, staticRenderFns } from "./setting-collect-account-list.vue?vue&type=template&id=93602728&"
import script from "./setting-collect-account-list.vue?vue&type=script&lang=js&"
export * from "./setting-collect-account-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports